import { Nillable } from '@web/utils';

export class PublicDiscountCodeSubmitEvent {
  public constructor(
    private readonly data: {
      discountCode: Nillable<string>;
    },
  ) {}

  public get discountCode(): Nillable<string> {
    return this.data.discountCode;
  }
}
